'use client';

import { getThemeColorValue } from '@/lib/theme';
import { ITheme, TCustomIcon, THeroIcon } from '../types';
import Icon from './Icon';

interface ContentListItemsProps {
  items: {
    text_en: string;
    text_cn: string;
    icon: THeroIcon | TCustomIcon;
  }[];
  language: 'en' | 'zh';
  theme: ITheme | null | undefined;
}

export default function ContentListItems({
  items,
  language,
  theme,
}: ContentListItemsProps) {
  const themeColor = getThemeColorValue(theme as ITheme);

  return (
    <div className="mt-8">
      <ul className="max-w-3xl mx-auto">
        {items.map((item, index) => (
          <li key={index} className="flex items-start mb-2">
            <Icon
              icon={item.icon}
              className="w-5 h-5 mr-3 mt-1 flex-shrink-0"
              style={{ color: themeColor }}
            />
            <span className="text-lg">
              {language === 'en' ? item.text_en : item.text_cn}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
